// Referral link handling: capture ?ref=CODE on landing, claim it after signup.
const KEY = "riq_ref";

export function storeRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get("ref") || "").trim().toUpperCase();
    if (code && /^[A-Z0-9]{4,10}$/.test(code)) {
      localStorage.setItem(KEY, code);
    }
  } catch {
    /* no-op */
  }
}

export function getStoredRef() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

// Attach the stored referral code to the current user. Safe to call after any auth —
// the backend only attaches it for brand-new users. Clears the code after one attempt.
export async function claimStoredReferral(api) {
  const code = getStoredRef();
  if (!code) return;
  try {
    await api.post("/referral/claim", { code });
  } catch {
    /* ignore — attribution is best-effort */
  } finally {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* no-op */
    }
  }
}
